import { queryClient } from 'v4/migration/queryClientSingleton';
import { myDashboardApi } from 'v5/api/dashboard/dashboard.api.connected';
import { myErrorService } from 'v5/services/front/ErrorService/ErrorService.connected';
import { createDashboardService } from './DashboardService.impl';

export const myDashboardService = createDashboardService({
  api: myDashboardApi,
  queryClient,
  services: {
    errorService: myErrorService
  }
});
